import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Stop = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Stop' {...props}>
    <rect width='16' height='16' x='4' y='4' fill='none' stroke='#000' strokeWidth='2' />
  </StyledIcon>
);
